/**
 * System Users Controller
 * Add / Edit System Users
 */

import { getName, remove } from 'app/helpers/entity'
import { leaveUnique } from 'app/helpers/array'
import FileSaver from 'file-saver'
import moment from 'moment/moment'

// controller mixins
SystemUsersCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * SystemUsersCtrl controller
 *
 * @class SystemUsersCtrl
 * @memberof mwApp/settings
 * @see mwApp/settings
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/settings.controller:SystemUsersCtrl
 */
/* @ngInject */
export default function SystemUsersCtrl ($scope, $http, authSvc, User, Rule) {
  var vm = this
  vm.mixes = [['tabsCtrlMixin', '', 'rules']]

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  /**
   * Current user
   *
   * @memberof mwApp/settings.controller:SystemUsersCtrl
   * @type {models.User}
   */
  vm.me = authSvc.getUser()

  $scope.getters = {
    caseInsensitiveFullName: function (row) {
      return (row.firstName + ' ' + row.lastName).toLowerCase()
    },
    caseInsensitiveEmail: function (row) {
      return row.email.toLowerCase()
    },
    caseInsensitiveCompany: function (row) {
      return row.company ? row.company.toLowerCase() : 'zzzzzzz'
    }
  }

  /**
   * Users list
   *
   * @memberof mwApp/settings.controller:SystemUsersCtrl
   * @name vm.users
   * @type {models.User[]}
   */

  // get users
  User.loadAll()
    .to(vm.users = [])
    .then(
      () => {
        // set rule name 'N/A' for users without rule, but not super aadmins
        vm.users.forEach(u => {
          if (!u.superAdmin && u.rule == null) {
            u.rule = { name: 'N/A' }
          }
        })
      }
    ).then(() => { $scope.loading = false })

  /**
   * Rules list
   *
   * @memberof mwApp/settings.controller:SystemUsersCtrl
   * @name vm.rules
   * @type {models.User[]}
   */

  // get rules
  Rule.loadAll()
    .to(vm.rules = [])

    // Filter out duplicate rules from response
    // see https://setplexapps.atlassian.net/browse/MW-2261
    // TODO: remove later
    .then(() => {
      vm.rules = vm.rules.filter((rule, i, self) =>
        self.findIndex(r => r.id === rule.id) === i
      )
    })

    .then(
      () => {
        vm.ruleNames = vm.rules.map(getName).filter(leaveUnique)
        vm.ruleNames.push({
          key: null,
          value: 'Super Admin'
        })
      }
    )

  /**
   * Delete user
   *
   * @memberof mwApp/settings.controller:SystemUsersCtrl
   * @param  {models.User} user
   */
  vm.deleteUser = function (user) {
    if (user.id !== vm.me.id) { // disable delete own user
      user._delete()
        .then(remove(vm.users)(user))
    }
  }

  /**
   * Delete rule
   *
   * @memberof mwApp/settings.controller:SystemUsersCtrl
   * @param  {models.Rule} rule
   */
  vm.deleteRule = function (rule) {
    if (rule.id !== vm.me.rule.id) { // disable remove own rule
      rule._delete()
        .then(remove(vm.rules)(rule))
        .then(() => {
          // remove this rule from users
          vm.users.forEach(u => {
            if (u.rule && u.rule.id === rule.id) {
              u.rule = null
            }
          })
        })
    }
  }

  vm.downloadUserLogs = function (user) {
    $http.get(`api/users/${user.id}/log`, { headers: { 'Content-Type': 'application/octet-stream' }, responseType: 'blob' }).then(res => {
      FileSaver.saveAs(res.data, user.email + ' ' + moment().format('DD-MM-YYYY HH-mm') + '.txt')
    })
  }
}
